import { Vamshiram } from "../../assets";
import { Tejase } from "../../assets";
import { Iwa } from "../../assets";

export const tiles = [
    {
      id:1,
      smallImages: [
        Vamshiram.VamC1,
        Vamshiram.VamC2,
        Vamshiram.VamC3,
        Vamshiram.VamC4,
        Vamshiram.VamC5,
        Vamshiram.VamC6,
        Vamshiram.VamC7,
        Vamshiram.VamC8,
        Vamshiram.VamC9,
        Vamshiram.VamC10,
        Vamshiram.VamC11,
        Vamshiram.VamC12,
        Vamshiram.VamC13,
        Vamshiram.VamC14

      ],
      title: "Vamsiram Niche",
      description: "",
   
    },
    {
      id:2,
      smallImages: [
        Iwa.IwaC1,
        Iwa.IwaC2,
        Iwa.IwaC3,
        Iwa.IwaC4,
        Iwa.IwaC5,
        Iwa.IwaC6,
        Iwa.IwaC7,
        Iwa.IwaC8,
        Iwa.IwaC9,
        Iwa.IwaC10,
        Iwa.IwaC11,
        Iwa.IwaC12,
        Iwa.IwaC13,
        Iwa.IwaC14,
        Iwa.IwaC15
      ],
      title: "IWA ",
      description: "",
    
    },
    {
      id:3,
      smallImages: [
        Tejase.Tejase1,
        Tejase.Tejase2,
        Tejase.Tejase3,
        Tejase.Tejase4,
        Tejase.Tejase5,
        Tejase.Tejase6,
        Tejase.Tejase7,
        Tejase.Tejase8,
        Tejase.Tejase9,
        Tejase.Tejase10,
        Tejase.Tejase11,
        Tejase.Tejase12,
        Tejase.Tejase13,
        Tejase.Tejase14,
        Tejase.Tejase15,
        Tejase.Tejase16,
        Tejase.Tejase17,
        Tejase.Tejase18,
        Tejase.Tejase19,
        Tejase.Tejase20,
        Tejase.Tejase21,
        Tejase.Tejase22,
        Tejase.Tejase23,
        Tejase.Tejase24,
        Tejase.Tejase25,
        Tejase.Tejase26,
        Tejase.Tejase27,
        Tejase.Tejase28,
        Tejase.Tejase29,
        Tejase.Tejase30,
        Tejase.Tejase31,
        Tejase.Tejase32,
        Tejase.Tejase33,
        Tejase.Tejase34,
        Tejase.Tejase35,
        Tejase.Tejase36,
        Tejase.Tejase37,
        Tejase.Tejase38,
        Tejase.Tejase39,
        Tejase.Tejase40,
        Tejase.Tejase41,
        Tejase.Tejase42,
        Tejase.Tejase43,
        Tejase.Tejase44,
        Tejase.Tejase45,
        Tejase.Tejase46,
        Tejase.Tejase47,
        Tejase.Tejase48,
        Tejase.Tejase49,
        Tejase.Tejase50,
        Tejase.Tejase51,
        Tejase.Tejase52,
        Tejase.Tejase53,
        Tejase.Tejase54
        
      ],
      title: "Tejase Group",
      description: "",
    
    },
    {
      id:4,
      smallImages: [
        // "https://images.unsplash.com/photo-1521747116042-5a810fda9664?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzNjUyOXwwfDF8c2VhcmNofDMyfHx0cmF2ZWx8ZW58MHx8fHwxNjUzNzExMjE0&ixlib=rb-1.2.1&q=80&w=400",
        // "https://images.unsplash.com/photo-1521747116042-5a810fda9664?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzNjUyOXwwfDF8c2VhcmNofDMyfHx0cmF2ZWx8ZW58MHx8fHwxNjUzNzExMjE0&ixlib=rb-1.2.1&q=80&w=400",
        // "https://images.unsplash.com/photo-1521747116042-5a810fda9664?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzNjUyOXwwfDF8c2VhcmNofDMyfHx0cmF2ZWx8ZW58MHx8fHwxNjUzNzExMjE0&ixlib=rb-1.2.1&q=80&w=400",
        // "https://images.unsplash.com/photo-1521747116042-5a810fda9664?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzNjUyOXwwfDF8c2VhcmNofDMyfHx0cmF2ZWx8ZW58MHx8fHwxNjUzNzExMjE0&ixlib=rb-1.2.1&q=80&w=400",
      ],
      title: "Verdant Bayleaf",
      description: "",
     
    },
  ];